import React from 'react';
import { Box, Divider, Toolbar } from '@mui/material';

import GreetingBanner from 'components/greetingBanner/GreetingBanner';
import LanguageBar from 'components/languageBar/LanguageBar';
import LogoButton from 'components/logoButton/LogoButton';
import LogoutButton from 'components/logoutButton/LogoutButton';

const DesktopMenu = (props) => {
    const { children, ownersName, toggleContactUsModal } = props;

    return (
        <React.Fragment>
            <Toolbar className="desktop-language-bar-container">
                <LanguageBar toggleContactUsModal={toggleContactUsModal} />
            </Toolbar>
            <Toolbar className="navigation-bar-container">
                <LogoButton />
                <Toolbar className="desktop-navigation-bar">
                    {children}
                    {children && (
                        <Box className="greeting-logout-container">
                            <GreetingBanner ownersName={ownersName} />
                            <Divider className="divider" flexItem orientation="vertical" variant="middle" />
                            <LogoutButton />
                        </Box>
                    )}
                </Toolbar>
            </Toolbar>
        </React.Fragment>
    );
};

export default DesktopMenu;
